import { create } from 'zustand';

export type PosCashSessionState = {
  activeCashSessionId: string | null;
  cashSessionLoading: boolean;
  /** Sucursal para la que ya resolvimos caja al menos una vez (evita re-mostrar "Verificando…"). */
  cashSessionHydratedForBranchId: string | null;
  cashSessionOpenedAt: string | null;
  cashSessionOpeningAmount: number | null;
  setActiveCashSessionId: (id: string | null) => void;
  setCashSessionLoading: (v: boolean) => void;
  applyCashSessionSnapshot: (
    branchId: string,
    session: { id: string; openedAt: string; openingAmount: number } | null
  ) => void;
  markCashSessionPendingForBranch: (branchId: string | null) => void;
};

export const usePosCashSessionStore = create<PosCashSessionState>((set) => ({
  activeCashSessionId: null,
  cashSessionLoading: true,
  cashSessionHydratedForBranchId: null,
  cashSessionOpenedAt: null,
  cashSessionOpeningAmount: null,

  setActiveCashSessionId: (id) =>
    set((state) => (state.activeCashSessionId === id ? state : { activeCashSessionId: id })),
  setCashSessionLoading: (v) =>
    set((state) => (state.cashSessionLoading === v ? state : { cashSessionLoading: v })),
  applyCashSessionSnapshot: (branchId, session) =>
    set((state) => {
      const sessionId = session?.id ?? null;
      const openedAt = session?.openedAt ?? null;
      const openingAmount = session?.openingAmount ?? null;
      if (
        state.cashSessionHydratedForBranchId === branchId &&
        state.activeCashSessionId === sessionId &&
        state.cashSessionLoading === false &&
        state.cashSessionOpenedAt === openedAt &&
        state.cashSessionOpeningAmount === openingAmount
      ) {
        return state;
      }
      return {
        activeCashSessionId: sessionId,
        cashSessionLoading: false,
        cashSessionHydratedForBranchId: branchId,
        cashSessionOpenedAt: openedAt,
        cashSessionOpeningAmount: openingAmount,
      };
    }),
  markCashSessionPendingForBranch: (branchId) =>
    set((state) => {
      if (branchId && state.cashSessionHydratedForBranchId === branchId) {
        return state;
      }
      if (!branchId) {
        return {
          cashSessionLoading: true,
          cashSessionHydratedForBranchId: null,
          activeCashSessionId: null,
          cashSessionOpenedAt: null,
          cashSessionOpeningAmount: null,
        };
      }
      return {
        cashSessionLoading: true,
        cashSessionHydratedForBranchId: null,
      };
    }),
}));
